import React, { useEffect, useRef } from 'react';


import cornerstoneWebImageLoader from 'cornerstone-web-image-loader';
import cornerstone from 'cornerstone-core';
import cornerstoneTools from 'cornerstone-tools';
import Hammer from "hammerjs";
import cornerstoneMath from "cornerstone-math";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import axios from "axios"
import Slide from '@mui/material/Slide';
import { DialogContent, Grid } from '@mui/material';
import ManualRegistrationImgViewer from '../ManualRegistrationImgViewer';
import { useDispatch, useSelector } from 'react-redux';

import { API_URL } from '../../config/endpoint';
import ProbeTool from '../cns/ProbeTool';
import { setImageMeta, setImages } from '../../redux/imageSlice';
import { setData } from '../../redux/annotationSlice';
import SquareGrid from '../cns/SquareGrid';
import CircleTool from '../cns/CircleTool';
import useSnackbar from './Snackbar';

cornerstoneTools.external.cornerstone = cornerstone;
cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
cornerstoneWebImageLoader.external.cornerstone = cornerstone;

cornerstoneTools.external.Hammer = Hammer;

cornerstoneTools.ProbeTool = ProbeTool
cornerstoneTools.SquareGrid = SquareGrid
cornerstoneTools.CircleTool = CircleTool

cornerstoneTools.init({ mouseEnabled: true });


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog() {
  const [open, setOpen] = React.useState(false);
  const [SnackbarComponent, showSnackbar] = useSnackbar();
  const images = useSelector(state => state.images)
  const dispatch = useDispatch()
  const [processing, setProcessing] = React.useState(false)

  const imageMaiaElement = useRef(null);
  const imageFullResElement = useRef(null);

  const [measurements, setMeasurements] = React.useState({
    maia_tgz_file: null, spectralis_high_res: null
  })
  const measurementsMan = useSelector(state => state.man_measurements)


  const onMeasurement = (id, data) => {
    setMeasurements({ ...measurements, [id]: data })
  }

  const onRegistrationClick = () => {
    if (measurementsMan.spectralis_high_res === null || measurementsMan.maia_tgz_file === null) {
      showSnackbar("Atleast 3 points per image required", "error")
      return
    }

    if (measurementsMan.spectralis_high_res.data.length < 3 || measurementsMan.maia_tgz_file.data.length < 3) {
      showSnackbar("Atleast 3 points per image required", "error")
      return
    }

    if (measurementsMan.spectralis_high_res.data.length !== measurementsMan.maia_tgz_file.data.length) {
      showSnackbar("Number of points on both images are not equal", "error")
      return
    }



    const data = {
      measurements: measurementsMan, uuid: images.uuid, selectedOption: images.maia_tgz_file.selectedOption,
      spectralis_high_res: images.spectralis_high_res.path, annotated_spectralis: images.annotated_spectralis.path,
      spectralis_report: images.spectralis_report.path, maia_tgz_file: images.maia_tgz_file.path,
    }
    setProcessing(true)
    axios.post(API_URL + "/manual-registration", data).then(res => {
      console.log(res)
      dispatch(setImages({
        name: 'selectedImage', value: res.data.url
      }))
      dispatch(setImages({
        name: 'registeredUrl', value: res.data.url
      }))
      dispatch(setImages({
        name: 'centerPoint', value: res.data.points
      }))
      dispatch(setImages({
        name: 'grid', value: res.data.grid
      }))
      dispatch(setImages({
        name: 'etdrs', value: res.data.etdrs
      }))
      dispatch(setData({
        name: 'octMaia', checked: false
      }))
      setProcessing(false)
      handleClose()

      cornerstoneTools.clearToolState(imageMaiaElement.current, 'Probe')
      cornerstoneTools.clearToolState(imageFullResElement.current, 'Probe')
      console.log(measurementsMan)
    }).catch(err => {
      console.log(err);
      setProcessing(false)

    });
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    cornerstoneTools.clearToolState(imageMaiaElement.current, 'Probe')
    cornerstoneTools.clearToolState(imageFullResElement.current, 'Probe')
  };

  return (
    <div>
      <SnackbarComponent />
      <Button variant="outlined" onClick={handleClickOpen}
        disabled={images.spectralis_high_res.url === null || images.maia_tgz_file.url === null}
        sx={{ textTransform: 'inherit' }}>
        Manual Registration
      </Button>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        {processing &&
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        }
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              disabled={processing}
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Manual Registration
            </Typography>
            <Button autoFocus color="secondary" variant='contained' onClick={onRegistrationClick}
              disabled={processing}>
              {processing ? 'Registering...' : 'Register'}
            </Button>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item md={6}>
              <ManualRegistrationImgViewer imageElement={imageFullResElement} id={"spectralis_high_res"} onMeasurement={onMeasurement} />
            </Grid>
            <Grid item md={6}>
              <ManualRegistrationImgViewer imageElement={imageMaiaElement} id={"maia_tgz_file"} onMeasurement={onMeasurement} />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}
